import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const EnrollmentIllustration = (props: SVGProps) => {
  const { title = 'EnrollmentIllustration', className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 304 204"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M213.468 185.027C213.628 174.567 190.572 165.73 161.97 165.29C133.369 164.85 110.052 172.973 109.892 183.434C109.732 193.894 132.788 202.731 161.389 203.171C189.991 203.611 213.307 195.488 213.468 185.027Z"
        fill="currentColor"
      />
      <path
        d="M109.891 182.264C109.734 192.728 133.043 201.567 161.639 202.001C190.235 202.434 213.553 194.315 213.718 183.851L214.004 165.342L110.425 164.18L109.891 182.264Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <mask
        id="mask0_7084_7620"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="108"
        y="164"
        width="107"
        height="40"
      >
        <path
          d="M108.61 182.915C108.453 193.378 132.765 203.168 161.371 203.602C189.977 204.044 214.805 195.851 214.962 185.388L214.261 166.934L109.144 164.821L108.61 182.906V182.915Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_7084_7620)">
        <path
          d="M114.736 170.378V193.584"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M124.133 174.893V198.108"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M133.521 179.927V203.133"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M142.918 182.287V205.493"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M152.314 182.287V205.493"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M161.712 183.481V206.696"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M171.109 182.287V205.493"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M180.506 181.986V205.192"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M189.902 179.927V203.133"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M199.3 176.249V199.454"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
        <path
          d="M207.905 170.378V200.375"
          stroke="#161718"
          strokeWidth="2.951"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M214.004 165.351C214.164 154.89 191.108 146.054 162.506 145.614C133.904 145.174 110.588 153.297 110.428 163.758C110.267 174.218 133.323 183.055 161.925 183.495C190.527 183.935 213.843 175.812 214.004 165.351Z"
        fill="#161718"
        stroke="white"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M205.07 164.304C205.089 157.603 185.916 152.117 162.246 152.051C138.577 151.985 119.374 157.363 119.355 164.064C119.336 170.765 138.509 176.251 162.179 176.318C185.848 176.384 205.051 171.005 205.07 164.304Z"
        fill="#161718"
        stroke="currentColor"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M213.463 147.761C213.624 137.3 190.568 128.463 161.966 128.023C133.364 127.583 110.048 135.707 109.888 146.167C109.727 156.628 132.783 165.465 161.385 165.905C189.987 166.345 213.303 158.221 213.463 147.761Z"
        fill="currentColor"
      />
      <path
        d="M108.61 164.862C108.453 175.325 132.765 185.115 161.371 185.549C189.977 185.992 215.266 177.438 215.431 166.975L214.962 148.189L108.61 142.837V164.853V164.862Z"
        fill="white"
      />
      <path
        d="M109.891 144.991C109.734 155.454 133.043 164.293 161.639 164.727C190.235 165.161 213.553 157.041 213.718 146.578L214.004 128.068L110.425 126.906L109.891 144.991Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M211.406 152.679C211.406 152.679 197.771 165.329 167.305 164.73"
        stroke="#161718"
        strokeWidth="3.44283"
        strokeMiterlimit="10"
      />
      <path
        d="M214.008 128.077C214.169 117.616 191.113 108.78 162.511 108.34C133.909 107.9 110.593 116.023 110.433 126.484C110.272 136.944 133.328 145.781 161.93 146.221C190.532 146.661 213.848 138.538 214.008 128.077Z"
        fill="#161718"
        stroke="white"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M205.071 127.031C205.089 120.33 185.916 114.844 162.247 114.777C138.577 114.711 119.374 120.09 119.356 126.791C119.337 133.492 138.51 138.978 162.179 139.044C185.849 139.11 205.052 133.732 205.071 127.031Z"
        fill="#161718"
        stroke="currentColor"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M160.201 127.827C186.033 127.827 206.974 106.854 206.974 80.9823C206.974 55.1105 186.033 34.1372 160.201 34.1372C134.369 34.1372 113.428 55.1105 113.428 80.9823C113.428 106.854 134.369 127.827 160.201 127.827Z"
        fill="white"
        stroke="white"
        strokeWidth="2.78378"
        strokeMiterlimit="10"
      />
      <path
        d="M166.059 127.827C191.891 127.827 212.832 106.854 212.832 80.9823C212.832 55.1105 191.891 34.1372 166.059 34.1372C140.227 34.1372 119.286 55.1105 119.286 80.9823C119.286 106.854 140.227 127.827 166.059 127.827Z"
        fill="currentColor"
      />
      <path
        d="M166.059 115.871C185.297 115.871 200.893 100.252 200.893 80.9842C200.893 61.7166 185.297 46.0972 166.059 46.0972C146.822 46.0972 131.226 61.7166 131.226 80.9842C131.226 100.252 146.822 115.871 166.059 115.871Z"
        stroke="#161718"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M168.339 100.081V105.497H165.852V100.025C157.201 99.5362 151.849 94.3415 152.337 86.7108H155.746C155.423 92.7729 159.532 96.3437 165.852 96.7774V81.839C159.578 80.7041 153.148 79.2923 153.148 72.04C153.148 65.5996 158.334 61.429 165.852 61.1061V57.9136H168.339V61.1615C176.447 61.8073 181.366 67.1128 180.123 74.2083H176.668C177.7 68.746 174.07 65.0091 168.339 64.4647V79.0801C174.715 80.215 181.366 81.6268 181.366 89.0913C181.366 95.8085 175.958 99.7023 168.339 100.081ZM165.852 78.5911V64.354C160.499 64.6215 156.713 67.3896 156.713 71.7724C156.713 76.1552 160.932 77.6223 165.852 78.5911ZM168.339 96.7774C174.125 96.5098 177.801 93.7417 177.801 89.3036C177.801 84.4871 173.425 83.2415 168.339 82.2634V96.7681V96.7774Z"
        fill="white"
      />
      <path
        d="M211.036 22.8689C220.323 22.8689 227.849 15.3305 227.849 6.02979C227.849 15.3305 235.376 22.8689 244.663 22.8689C235.376 22.8689 227.849 30.4073 227.849 39.708C227.849 30.4073 220.323 22.8689 211.036 22.8689Z"
        fill="white"
      />
      <path
        d="M211.036 22.8689C220.323 22.8689 227.849 15.3305 227.849 6.02979C227.849 15.3305 235.376 22.8689 244.663 22.8689C235.376 22.8689 227.849 30.4073 227.849 39.708C227.849 30.4073 220.323 22.8689 211.036 22.8689Z"
        stroke="white"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M252.181 56.5479C259.192 56.5479 263.945 50.9102 263.945 43.9531C263.945 50.9102 269.62 56.5479 276.631 56.5479C269.62 56.5479 263.945 62.1855 263.945 69.1426C263.945 62.1855 259.192 56.5479 252.181 56.5479Z"
        stroke="white"
        strokeWidth="2.951"
        strokeMiterlimit="10"
      />
      <path
        d="M53.4502 69.4612L53.4502 151.939H67.4095V69.4612H53.4502Z"
        stroke="white"
        strokeWidth="2.94932"
        strokeMiterlimit="10"
      />
      <path
        d="M53.4614 51.5206V69.709H67.4207V51.5206H53.4614Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.94932"
        strokeMiterlimit="10"
      />
      <path
        d="M27.4683 123.699V151.939H41.4276V123.699H27.4683Z"
        stroke="white"
        strokeWidth="2.94932"
        strokeMiterlimit="10"
      />
      <path
        d="M27.4683 80.2715L27.4683 123.96H41.4276V80.2715H27.4683Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.94932"
        strokeMiterlimit="10"
      />
      <path
        d="M1.47461 136.353L1.47461 151.947H15.4339L15.4339 136.353H1.47461Z"
        stroke="white"
        strokeWidth="2.94932"
        strokeMiterlimit="10"
      />
      <path
        d="M1.47461 111.562L1.47461 136.601H15.4339L15.4339 111.562H1.47461Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.94932"
        strokeMiterlimit="10"
      />
      <path
        d="M301.642 110.452L253.299 161.93"
        stroke="currentColor"
        strokeWidth="3.12926"
        strokeMiterlimit="10"
      />
      <path
        d="M275.875 110.452H301.643V136.259"
        stroke="currentColor"
        strokeWidth="3.12926"
        strokeMiterlimit="10"
      />
      <path
        d="M301.642 160.599L272.146 192.007"
        stroke="currentColor"
        strokeWidth="3.12926"
        strokeMiterlimit="10"
      />
      <path
        d="M275.875 160.599H301.643V186.406"
        stroke="currentColor"
        strokeWidth="3.12926"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

EnrollmentIllustration.displayName = 'EnrollmentIllustration';
